import React, { useEffect, useState } from "react";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import { QUESTIONNAIRE_LIST, QUESTIONNAIRE_LIST_EMP } from "../UI/Table/ColumnConst";
import { userloginDetails } from "../Utils/AdminAuth";
import Axios from "../../axios/Axios";
import { NODE_HOST_URL_v2 } from "../Dashboard/api/Api";
import Spining from "../UI/Spining/Spining";

const QuestionnaireList = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const userType = lStorage?.user?.isAdmin;

    const [questionnaireList, setQuestionnaireList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchQuestionnaireList = async () => {
        setIsLoading(true);
        try {
            const payload = { user_id: userId, token: userToken };
            const url = userType === "emp"
                ? `https://napi.authkey.io/api2/v1/emp/questioner`
                : `${NODE_HOST_URL_v2}/admin/questioner`;

            const response = await Axios.post(url, payload);
            const result = response.data;
            if (result.success === true) {
                setQuestionnaireList(result.message);
            } else {
                setQuestionnaireList([]);
            }
        } catch (error) {
            setQuestionnaireList([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchQuestionnaireList();
    }, []);

    return (
        <div className="wrapper">
            <AdminLeftMenu />
            <div className="main">
                <AdminHeader />
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3 align-items-center">
                            <div className="col-auto d-none d-sm-block">
                                <h3>
                                    <strong>Questionnaire List</strong>
                                </h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="card-body p-0">
                                    {isLoading ? (
                                        <Spining />
                                    ) : (
                                        <AdvanceDataTable
                                            tableCell={userType === "emp" ? QUESTIONNAIRE_LIST_EMP : QUESTIONNAIRE_LIST}
                                            tableData={questionnaireList}
                                            pagination={true}
                                            filterstatus={true}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <AdminFooter />
            </div>
        </div>
    );
};

export default QuestionnaireList;
